import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  const AMPLITUDE_API_KEY = config.public.amplitudeUrl;

  // Defer amplitude init until after page load — keeps it out of critical path
  let amplitudeInstance: any = null;

  const getAmplitude = async () => {
    if (!amplitudeInstance) {
      const amp = await import('@amplitude/analytics-browser');
      amp.init(AMPLITUDE_API_KEY, undefined, { defaultTracking: true });
      amplitudeInstance = amp;
    }
    return amplitudeInstance;
  };

  // Stub that queues calls until amplitude is ready
  const stub = {
    track: (...args: any[]) => getAmplitude().then(a => a.track(...args)),
    identify: (...args: any[]) => getAmplitude().then(a => a.identify(...args)),
    setUserId: (...args: any[]) => getAmplitude().then(a => a.setUserId(...args)),
    init: () => {},
  };

  // Load after window load event to not block LCP/TTI
  if (typeof window !== 'undefined') {
    window.addEventListener('load', () => {
      setTimeout(() => getAmplitude(), 2000);
    }, { once: true });
  }

  nuxtApp.provide('amplitude', stub);
});
